import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { AboutEntity } from "../types/AboutEntity";

const AboutApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        AboutLoad: builder.query<AboutEntity, void>({
            query: () => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ABOUT}`,
                    method: "GET",
                };
            },
        }),
    }),
});

export const { useAboutLoadQuery } = AboutApi;
